import './ContentContainer.scss';

import { ElementType, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  containerClass?: string;
  contentClass?: string;
  component?: ElementType;
}

const ContentContainer = ({
  children,
  containerClass = '',
  contentClass = '',
  component: Component = 'section',
}: IProps) => {
  return (
    <div className={`${containerClass} content-container`}>
      <Component className={`container-xxl ${contentClass}`}>{children}</Component>
    </div>
  );
};

export default ContentContainer;
